import { Injectable } from '@angular/core';
import { DistriApiService } from './distri.api.service';

@Injectable({
  providedIn: 'root'
})
export class DistriClientsService {

  constructor(private api: DistriApiService) { }

  findDistriByLogin(login: any) {
    return this.api.get('/common/clients/distri/search-by-login?a=' + login);
  }
  saveEtatDistri(id:any, etat: any) {
    return this.api.get('/common/clients/distri/save-etat?id='+id+'&etat='+etat);
  }

  updateClient(obj: any) {
    return this.api.post('common/clients/update', obj);
  }
  findByLogin3(login: any) {
    return this.api.get('/common/clients/distri/search-by-login3?a=' + login);
  }

  findByLogin2(login: any) {
    return this.api.get('/common/clients/search-by-login2?a=' + login);
  }

  findByLogin(login: any) {
    return this.api.get('/common/clients/search-by-login?a=' + login);
  }

  findByLoginOmy(login: any) {
    return this.api.get('/common/clients/search-by-login-omy?a=' + login);
  }
  findByLoginTelco(login: any) {
    return this.api.get('/common/clients/search-by-login-telco?a=' + login);
  }

  findAgents() {
    return this.api.get('/common/clients/agents');
  }

  findProduits() {
    return this.api.get('/common/clients/search-produits');
  }

  searchMsisdn(login: any) {
    return this.api.get('/common/clients/search-msisdn?a=' + login);
  }

  searchLastCommandes(login: any) {
    return this.api.get('/common/clients/search-last-commandes?a=' + login);
  }

  
}
//76137694;610025063887175;93826259;610025033625778


